import { render, staticRenderFns } from "./sportRules.vue?vue&type=template&id=86a19f60&scoped=true"
import script from "./sportRules.vue?vue&type=script&lang=js"
export * from "./sportRules.vue?vue&type=script&lang=js"
import style0 from "./sportRules.vue?vue&type=style&index=0&id=86a19f60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a19f60",
  null
  
)

export default component.exports